import React from 'react'
import { makeStyles } from '@material-ui/styles';
import {
  PROPOSAL_LIST_STATUS,
} from '../../../utils/ConstantsMain';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@material-ui/core';
import ButtonBase from '../../../components/Buttons/ButtonBase';

const useStyles = makeStyles({
  textField: {
    maxWidth: 304,
    margin: '10px 0 24px',
    height: 48,
    padding: 0,
  },
  inputLabelRoot: {
    transform: 'translate(14px, 16px) scale(1)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    right: 22,
    bottom: 0,
    paddingRight: 20,
  },
  inputLabelShrink: {
    transform: 'translate(14px, -6px) scale(0.75)',
    zIndex: 10,
    right: 'unset',
    backgroundColor: '#fff',
    height: 'fit-content',
  },
  buttons: {
    margin: '8px 0 0',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  ButtonBase: {
    minWidth: 136,
    margin: '0 0 0 16px',
  },
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },
});

const ChangeStatusForm = (props) => {
  const {
    values,
    handleChange,
    touched,
    errors,
    isValid,
    handleSubmit,
    handleClose,
  } = props;

  const classes = useStyles();
  return (
    <form onSubmit={handleSubmit}>
      <div>
        <FormControl
          classes={{ root: classes.textField }}
          variant="outlined"
          error={touched.status && errors.status ? true : false}
        >
          <InputLabel
            htmlFor="select-multiple-checkbox"
            classes={{
              root: classes.inputLabelRoot,
              shrink: classes.inputLabelShrink,
            }}
          >
            {'Selecciona estatus de la propuesta'}
          </InputLabel>
          <Select
            name="status"
            value={values.status ? values.status : []}
            onChange={handleChange}
          >
            {PROPOSAL_LIST_STATUS &&
              PROPOSAL_LIST_STATUS.map((item, index) => (
                <MenuItem key={index} value={item.value}>
                  {item.name}
                </MenuItem>
              ))}
          </Select>
          {touched.status && errors.status ? (
            <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
              {errors.status}
            </FormHelperText>
          ) : (
            ''
          )}
        </FormControl>
      </div>

      <div className={classes.buttons}>
        <ButtonBase
          onClick={(e) => {
            e.preventDefault()
            handleClose()
          }}
          variant="primary"
          className={classes.ButtonBase}
        >
          Cancelar
        </ButtonBase>
        <ButtonBase
          type="submit"
          variant="primaryOutlined2"
          className={classes.ButtonBase}
          isValid={isValid}
        >
          Guardar
        </ButtonBase>
      </div>
    </form>
  )
}

export default ChangeStatusForm
